export const TransportMappings = {
  J: 'Train',
  B: 'Bus'
}
